export const mapperToPurchaseOrder = (data: any) => {
    return [
        {
          id: "dados",
          value: data.codemp
            ? {
                codemp: data.codemp,
                nomemp: data.nomemp,
                sigemp: data.sigemp,
              }
            : null,
          required: true,
        },
        {
          id: "filiais",
          value: data.codfil
            ? {
                codfil: data.codfil,
                nomfil: data.nomfil,
              }
            : null,
          required: true,
        },
        {
          id: 'fornecedor',
          value: data.codfor ? {
            codfor: data.codfor,
            nomfor: data.nomfor,
            cgccpf: data.cgccpf,
          } : null,
          required: true,
        },
        {
          id: 'obs',
          value: data.obs ? data.obs : '',
          required: true,
        },
        {
          id: 'transacao',
          value: data.codtns ? {
            codtns: data.codtns,
            destns: data.destns,
          } : null,
          required: true,
        },
        {
          id: 'condPgto',
          value: data.codcpg ? {
            codcpg: data.codcpg,
            descpg: data.descpg,
          } : null,
          required: true,
        },
        {
          id: 'itens',
          value: data.ItemEmissaOrdemCompra ? data.ItemEmissaOrdemCompra?.map((item:any) => mapperToPurchaseOrderItem(item)) : [],
          required: true,
        },
        {
          id: 'parcelas',
          value: data.parcelas ? data.parcelas?.map((item:any) => mapperToPurchaseOrderParcela(item)) : [],
          required: false,
        },
        {
          id: 'datemi',
          value: {
            datemi: data.datemi ? new Date(data.datemi).toISOString().split('T')[0]  : new Date().toISOString().split('T')[0],
          },
          required: true,
        },
        {
          id: 'arquivos',
          value: {
            arquivos: data.arquivos ? data.arquivos.map((arquivo: any) => bufferToFile(arquivo)) : [],
          },
          required: true,
        },
      ];
}

export const mapperToPurchaseOrderItem = (data: any) => {
    return [
        {
          id: 'produto',
          value: data.tipo === 'produto' ? {
            codpro: data.coditem,
            despro: data.desitem,
          } : null,
          required: false,
        },
        {
          id: 'servico',
          value: data.tipo === 'servico' ? {
            codser: data.coditem,
            desser: data.desitem,
          } : null,
          required: false,
        },
        {
          id: 'qtd',
          value: data.qtd ? {
            qtd: data.qtd,
          } : {
            qtd: 1,
          },
          required: true,
        },
        {
          id: 'derivacao',
          value: data.codder ? {
            codder: data.codder,
            desder: data.desder,
          } : null,
          required: false,
        },
        {
          id: 'valorunitario',
          value: data.valorunitario ? {
            valorunitario: data.valorunitario,
          } : {
            valorunitario: 1,
          },
          required: true,
        },
        {
          id: 'unidademedida',
          value: data.unidademedida ? data.unidademedida : '',
          required: true,
        },
        {
          id: 'tipo',
          value: data.tipo ? {
            tipo: data.tipo,
          } : {
            tipo: 'produto',
          },
          required: true,
        },
        {
          id: 'datprv',
          value: {
            datprv: data.datprv ? new Date(data.datprv).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
          },
          required: true,
        },
        {
          id: "centrosCusto",
          value: data.codccu
            ? {
                codccu: data.codccu,
                desccu: data.desccu,
              }
            : null,
          required: true,
        },
        {
          id: 'ctaFinanceira',
          value: data.codFinanceira ? {
            codFinanceira: data.codFinanceira,
            desFinanceira: data.desFinanceira,
          } : null,
          required: true,
        },
        {
          id: 'ctaContabil',
          value: data.codContabil ? {
            codContabil: data.codContabil,
            desContabil: data.desContabil,
          } : null,
          required: false,
        },
      ];
}

export const mapperToPurchaseOrderParcela = (data: any) => {
    return [
        {
          id: 'vlrpar',
          value: data.vlrpar ? {
            vlrpar: data.vlrpar,
          } : {
            vlrpar: 1,
          },
          required: true,
        },
        {
          id: 'vctpar',
          value: {
            vctpar: data.vctpar ? new Date(data.vctpar).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
          },
          required: true,
        },
        {
          id: 'seqpar',
          value: data.seqpar ? {
            seqpar: data.seqpar,
          } : {
            seqpar: 1,
          },
          required: true,
        },
      ];
}

function bufferToFile(arquivoBackend: {
  dados: { type: string; data: number[] };
  nome: string;
  tipo: string;
}): File {
  const byteArray = new Uint8Array(arquivoBackend.dados.data);
  const blob = new Blob([byteArray], { type: arquivoBackend.tipo });

  return new File([blob], arquivoBackend.nome, { type: arquivoBackend.tipo });
}